// ============================================================
// FICHIER : boutique/modules/notifications.js
// RÔLE : Système de notifications (toasts) du widget.
//        Indique à l'utilisateur l'état d'une requête : succès,
//        erreur, avertissement ou information. Rendus dans le
//        Shadow DOM du widget.
// ============================================================

window.Toilesia = window.Toilesia || {};
(function () {
    'use strict';

    let _conteneur = null;

    /**
     * Initialise le conteneur de toasts dans la racine du widget.
     * Appelable plusieurs fois (mode widget ou page produit) : l'ancien
     * conteneur est retiré et remplacé dans la nouvelle racine.
     * @param {ShadowRoot} racine Shadow Root du widget / du panneau
     */
    function initialiser(racine) {
        if (_conteneur && _conteneur.parentNode) {
            _conteneur.parentNode.removeChild(_conteneur);
        }
        _conteneur = document.createElement('div');
        _conteneur.className = 'tls-toasts';
        _conteneur.setAttribute('aria-live', 'polite');
        racine.appendChild(_conteneur);
    }

    /**
     * Affiche un toast et le retire automatiquement après la durée.
     * @param {string} type    'succes' | 'erreur' | 'avertissement' | 'info'
     * @param {string} message Texte à afficher
     * @param {number|null} duree Durée d'affichage (ms) ; null = persistant
     * @returns {HTMLElement|undefined} L'élément toast (pour le retirer)
     */
    function afficher(type, message, duree) {
        if (!_conteneur) return;

        const toast = document.createElement('div');
        toast.className = 'tls-toast tls-toast-' + type;

        const icone = document.createElement('span');
        icone.className = 'tls-toast-icone';
        icone.textContent = iconeParType(type);

        const texte = document.createElement('span');
        texte.className = 'tls-toast-texte';
        texte.textContent = message;

        const fermer = document.createElement('button');
        fermer.className = 'tls-toast-fermer';
        fermer.setAttribute('aria-label', 'Fermer la notification');
        fermer.textContent = '✕';
        fermer.addEventListener('click', () => retirer(toast));

        toast.appendChild(icone);
        toast.appendChild(texte);
        toast.appendChild(fermer);
        _conteneur.appendChild(toast);

        // Force le rendu avant d'ajouter la classe d'apparition
        requestAnimationFrame(() => toast.classList.add('tls-visible'));

        if (duree !== null && duree !== undefined) {
            setTimeout(() => retirer(toast), duree);
        }
        return toast;
    }

    function retirer(toast) {
        if (!toast.parentNode) return;
        toast.classList.remove('tls-visible');
        toast.classList.add('tls-cache');
        setTimeout(() => toast.remove(), 300);
    }

    function iconeParType(type) {
        switch (type) {
            case 'succes':         return '✓';
            case 'erreur':         return '✕';
            case 'avertissement':  return '⚠';
            default:               return 'ℹ';
        }
    }

    Toilesia.notifier = {
        initialiser: initialiser,
        afficher: afficher,
        succes: (m, d) => afficher('succes', m, d === undefined ? 4000 : d),
        erreur: (m, d) => afficher('erreur', m, d === undefined ? 8000 : d),
        avertissement: (m, d) => afficher('avertissement', m, d === undefined ? 6000 : d),
        info: (m, d) => afficher('info', m, d === undefined ? 4000 : d)
    };
})();
